export default __webpack_public_path__ + "static/media/icon_ui_capturensave.974b9f37.png";